/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OverviewSecretsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OverviewSecretsQuery = { __typename?: 'QueryPrediction', secrets: Array<{ __typename?: 'SecretType', id: string } | null | undefined> | null | undefined };

export type OverviewWebhookSecretsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OverviewWebhookSecretsQuery = { __typename?: 'QueryPrediction', webhookSecrets: Array<{ __typename?: 'WebhookSigningSecretType', id: string } | null | undefined> | null | undefined };

export type OverviewUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OverviewUsersQuery = { __typename?: 'QueryPrediction', users: Array<{ __typename?: 'UserType', id: string } | null | undefined> | null | undefined };

export type OverviewUserApiKeysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OverviewUserApiKeysQuery = { __typename?: 'QueryPrediction', userApiKeys: Array<{ __typename?: 'UserAPIKeyType', id: string | null | undefined, revoked: boolean } | null | undefined> | null | undefined };

export type OverviewOrgApiKeysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OverviewOrgApiKeysQuery = { __typename?: 'QueryPrediction', orgApiKeys: Array<{ __typename?: 'UserAPIKeyType', id: string | null | undefined, revoked: boolean } | null | undefined> | null | undefined };


export const OverviewSecretsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewSecrets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"secrets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OverviewSecretsQuery, OverviewSecretsQueryVariables>;
export const OverviewWebhookSecretsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewWebhookSecrets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"webhookSecrets"},"name":{"kind":"Name","value":"webhook_signing_secrets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OverviewWebhookSecretsQuery, OverviewWebhookSecretsQueryVariables>;
export const OverviewUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OverviewUsersQuery, OverviewUsersQueryVariables>;
export const OverviewUserApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewUserApiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userApiKeys"},"name":{"kind":"Name","value":"user_api_keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revoked"}}]}}]}}]} as unknown as DocumentNode<OverviewUserApiKeysQuery, OverviewUserApiKeysQueryVariables>;
export const OverviewOrgApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewOrgApiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"orgApiKeys"},"name":{"kind":"Name","value":"org_api_keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revoked"}}]}}]}}]} as unknown as DocumentNode<OverviewOrgApiKeysQuery, OverviewOrgApiKeysQueryVariables>;
export const namedOperations = {
  Query: {
    OverviewSecrets: 'OverviewSecrets',
    OverviewWebhookSecrets: 'OverviewWebhookSecrets',
    OverviewUsers: 'OverviewUsers',
    OverviewUserApiKeys: 'OverviewUserApiKeys',
    OverviewOrgApiKeys: 'OverviewOrgApiKeys'
  }
}

/**
 * __useOverviewSecretsQuery__
 *
 * To run a query within a React component, call `useOverviewSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewSecretsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOverviewSecretsQuery(baseOptions?: Apollo.QueryHookOptions<OverviewSecretsQuery, OverviewSecretsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewSecretsQuery, OverviewSecretsQueryVariables>(OverviewSecretsDocument, options);
      }
export function useOverviewSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewSecretsQuery, OverviewSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewSecretsQuery, OverviewSecretsQueryVariables>(OverviewSecretsDocument, options);
        }
export type OverviewSecretsQueryHookResult = ReturnType<typeof useOverviewSecretsQuery>;
export type OverviewSecretsLazyQueryHookResult = ReturnType<typeof useOverviewSecretsLazyQuery>;
export type OverviewSecretsQueryResult = Apollo.QueryResult<OverviewSecretsQuery, OverviewSecretsQueryVariables>;
export function refetchOverviewSecretsQuery(variables?: OverviewSecretsQueryVariables) {
      return { query: OverviewSecretsDocument, variables: variables }
    }
/**
 * __useOverviewWebhookSecretsQuery__
 *
 * To run a query within a React component, call `useOverviewWebhookSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewWebhookSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewWebhookSecretsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOverviewWebhookSecretsQuery(baseOptions?: Apollo.QueryHookOptions<OverviewWebhookSecretsQuery, OverviewWebhookSecretsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewWebhookSecretsQuery, OverviewWebhookSecretsQueryVariables>(OverviewWebhookSecretsDocument, options);
      }
export function useOverviewWebhookSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewWebhookSecretsQuery, OverviewWebhookSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewWebhookSecretsQuery, OverviewWebhookSecretsQueryVariables>(OverviewWebhookSecretsDocument, options);
        }
export type OverviewWebhookSecretsQueryHookResult = ReturnType<typeof useOverviewWebhookSecretsQuery>;
export type OverviewWebhookSecretsLazyQueryHookResult = ReturnType<typeof useOverviewWebhookSecretsLazyQuery>;
export type OverviewWebhookSecretsQueryResult = Apollo.QueryResult<OverviewWebhookSecretsQuery, OverviewWebhookSecretsQueryVariables>;
export function refetchOverviewWebhookSecretsQuery(variables?: OverviewWebhookSecretsQueryVariables) {
      return { query: OverviewWebhookSecretsDocument, variables: variables }
    }
/**
 * __useOverviewUsersQuery__
 *
 * To run a query within a React component, call `useOverviewUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOverviewUsersQuery(baseOptions?: Apollo.QueryHookOptions<OverviewUsersQuery, OverviewUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewUsersQuery, OverviewUsersQueryVariables>(OverviewUsersDocument, options);
      }
export function useOverviewUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewUsersQuery, OverviewUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewUsersQuery, OverviewUsersQueryVariables>(OverviewUsersDocument, options);
        }
export type OverviewUsersQueryHookResult = ReturnType<typeof useOverviewUsersQuery>;
export type OverviewUsersLazyQueryHookResult = ReturnType<typeof useOverviewUsersLazyQuery>;
export type OverviewUsersQueryResult = Apollo.QueryResult<OverviewUsersQuery, OverviewUsersQueryVariables>;
export function refetchOverviewUsersQuery(variables?: OverviewUsersQueryVariables) {
      return { query: OverviewUsersDocument, variables: variables }
    }
/**
 * __useOverviewUserApiKeysQuery__
 *
 * To run a query within a React component, call `useOverviewUserApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewUserApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewUserApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useOverviewUserApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<OverviewUserApiKeysQuery, OverviewUserApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewUserApiKeysQuery, OverviewUserApiKeysQueryVariables>(OverviewUserApiKeysDocument, options);
      }
export function useOverviewUserApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewUserApiKeysQuery, OverviewUserApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewUserApiKeysQuery, OverviewUserApiKeysQueryVariables>(OverviewUserApiKeysDocument, options);
        }
export type OverviewUserApiKeysQueryHookResult = ReturnType<typeof useOverviewUserApiKeysQuery>;
export type OverviewUserApiKeysLazyQueryHookResult = ReturnType<typeof useOverviewUserApiKeysLazyQuery>;
export type OverviewUserApiKeysQueryResult = Apollo.QueryResult<OverviewUserApiKeysQuery, OverviewUserApiKeysQueryVariables>;
export function refetchOverviewUserApiKeysQuery(variables?: OverviewUserApiKeysQueryVariables) {
      return { query: OverviewUserApiKeysDocument, variables: variables }
    }
/**
 * __useOverviewOrgApiKeysQuery__
 *
 * To run a query within a React component, call `useOverviewOrgApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewOrgApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewOrgApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useOverviewOrgApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<OverviewOrgApiKeysQuery, OverviewOrgApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewOrgApiKeysQuery, OverviewOrgApiKeysQueryVariables>(OverviewOrgApiKeysDocument, options);
      }
export function useOverviewOrgApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewOrgApiKeysQuery, OverviewOrgApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewOrgApiKeysQuery, OverviewOrgApiKeysQueryVariables>(OverviewOrgApiKeysDocument, options);
        }
export type OverviewOrgApiKeysQueryHookResult = ReturnType<typeof useOverviewOrgApiKeysQuery>;
export type OverviewOrgApiKeysLazyQueryHookResult = ReturnType<typeof useOverviewOrgApiKeysLazyQuery>;
export type OverviewOrgApiKeysQueryResult = Apollo.QueryResult<OverviewOrgApiKeysQuery, OverviewOrgApiKeysQueryVariables>;
export function refetchOverviewOrgApiKeysQuery(variables?: OverviewOrgApiKeysQueryVariables) {
      return { query: OverviewOrgApiKeysDocument, variables: variables }
    }